import type { GeneralProductionUnit } from "../../../shared/general-production";

const numbers = new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 2 });
export const generalQuantity = (value: number | null) => value === null ? "—" : numbers.format(value);
export const generalUnit: Record<GeneralProductionUnit, string> = { kg: "KG", koli: "KOLİ", adet: "ADET" };
export const generalDate = (value: string, long = false) => new Intl.DateTimeFormat("tr-TR", {
  day: "numeric", month: long ? "long" : "short", weekday: long ? "long" : "short", timeZone: "Europe/Istanbul",
}).format(new Date(`${value}T12:00:00Z`));
